export default __webpack_public_path__ + "static/media/despertar-1920x1080.c9d45c6c.png";